module.exports = {"id":"211899","name":"Florian Niederlechner","rating":"75","photo":"./data/images/photos/1/211899.png","club":{"name":"SC Fribourg","logo":"./data/images/clubs/SCFribourg.png"},"positions":["BU"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/FlorianNiederlechner0.json
// module id = 1454
// module chunks = 0